import { call, takeLatest } from 'redux-saga/effects';
import { putSession } from '../../../globals/api/requests';

export function* addCookie({ version }) {
  try {
    yield call(putSession, 'cookie_consent_version', version);
  } catch (error) {
    throw error;
  }
}

function* mySaga() {
  yield takeLatest('ACCEPT_COOKIES', addCookie);
}

export default mySaga;
